import MotifsAjustementStockController from './motifs.ajustement.stock.controller';

export default {
    template: require('./motifs.ajustement.stock.tpl.html'),
    controller: MotifsAjustementStockController
};
